import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';

import { Filters, SearchParams } from 'types/clientList';
import { PAGE_LIMIT } from 'config/constants';
import {
  transformToListRequestQuery,
  transformToListResponseQuery,
} from '../../utils';

export const useSearchParams = (): SearchParams => {
  const location = useLocation();
  const history = useHistory();

  const {
    direction = 2,
    limit = PAGE_LIMIT,
    name = 'createdAt',
    page = 0,
    search,
    status,
  } = transformToListResponseQuery(qs.parse(location.search));

  const filters = {
    ...(search && { search }),
    status,
  };
  const sorters = { direction, name };
  const pagination = { page: page + 1, limit };

  const setSearchParams = (data) => {
    const search = qs.stringify(transformToListRequestQuery(data));
    history.push({ search });
  };

  const searchParams = { filters, sorters, pagination };
  return [searchParams, setSearchParams];
};

export const usePagination = (props: Pages): Pagination<Pages> => {
  const { limit: initialLimit, page: initialPage } = props;
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);

  return { setPage, setLimit, page, limit };
};

export const useFiltration = (props: {
  filters?: Filters;
  sorters?: Sorters;
}): Filtration<Filters, Sorters> => {
  const {
    filters: initialFilters = {},
    sorters: initialSorters = { name: '', direction: 0 },
  } = props;
  const [filters, setFilters] = useState(initialFilters);
  const [sorters, setSorters] = useState(initialSorters);

  return {
    setFilters,
    setSorters,
    filters,
    sorters,
  };
};
